<template>
  <div class="devel-box">
    <div class="section-title">
      <img class="" src="../assets/images/development-title.png" alt="" />
    </div>
    <div class="body-box">
      <div class="timer-shaft-box">
        <div class="timer-left">上一年</div>
          <div class="timer-right">下一年</div>
        <div class="timer-shaft">

          <div class="timer-scale">
            <div class="timer-scale-cont" v-for="(item,index) in timedata" :key="index">
              <div class="time-circle">

                <img class="timeimg" :src="item.newimg" alt="">

              </div>
              <p class="line-scale"></p>
              <div class="time">{{item.time}}年</div>

              <div class="time-content" :class="'times'+ index+ ''" v-for="(i,index) in item.content" :key="index" >
                <div v-if="index <1">
                  <p class="text1">{{i.text1}}</p>
                <p class="text2">{{i.text2}}</p>
                </div>
                <div class="hov-text">
                  <div class="text1-hov">{{i.text1}}</div>
                  <div class="text2-hov">{{i.text2}}</div>
                  <div class="text3-hov">{{i.text3}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      timedata: [
        {
          time: '2006',
          content: [
            {
              text1: '公司成立',
              text2: '北京博奥中成信息科技有限责任公司'
            }
          ],
          newimg: require('../assets/images/time-list1.png')
        },
        {
          time: '2008',
          content: [
            {
              text1: '人力资源和社会保障部',
              text2: '与博奥合作开展',
              text3: '职业资格院校鉴定过程化考核管理'
            }
          ],
          newimg: require('../assets/images/time-list2.png')
        }, {
          time: '2009',
          content: [
            {
              text1: '中央广播电视大学',
              text2: '与博奥合作开展',
              text3: '电大职业导向式技能人才培养教学模式'
            }
          ],
          newimg: require('../assets/images/time-list3.png')
        },
        {
          time: '2011',
          content: [
            {
              text1: '国家安全生产监督管理总局',
              text2: '与博奥联合运营',
              text3: '全国安全评价网络教育项目'
            }
          ],
          newimg: require('../assets/images/time-list4.png')
        },
        {
          time: '2013',
          content: [
            {
              text1: '交通运输部',
              text2: '与博奥合作运营',
              text3: '全国道路运输驾驶员继续教育网络项目'
            }
          ],
          newimg: require('../assets/images/time-list5.png')
        },
        {
          time: '2014',
          content: [
            {
              text1: '中华人民共和国生态环境部',
              text2: '与博奥开展',
              text3: '全国环境行业从业人员网络培训管理项目'
            },
            {
              text1: '中国环境影响评价协会',
              text2: '与博奥合作运营',
              text3: '职业技能等级评价管理'
            }
          ],
          newimg: require('../assets/images/time-list6.png')
        },
        {
          time: '2015',
          content: [
            {
              text1: '中国国电集团',
              text2: '与博奥合作',
              text3: '公司自主开发的职业教育数字教学资源(网络学院）'
            }
          ],
          newimg: require('../assets/images/time-list7.png')
        },
        {
          time: '2016',
          content: [
            {
              text1: '住房和城乡建设部',
              text2: '与博奥合作开展',
              text3: '住建行业从业人员信息管理系统'
            },
            {
              text1: '中国建设教育协会 ',
              text2: '',
              text3: '住房城乡建设领域BIM应用专业技能培训考试综合服务项目'
            }
          ],
          newimg: require('../assets/images/time-list8.png')
        },
        {
          time: '2017',
          content: [
            {
              text1: '完成股改',
              text2: '更名',
              text3: '北京博奥网络教育科技股份有限公司'
            }
          ],
          newimg: require('../assets/images/time-list9.png')
        },
        {
          time: '2018',
          content: [
            {
              text1: '人力资源和社会保障部住房和城乡建设部',
              text2: '博奥承办',
              text3: '全国装配式建筑职业技能竞赛与培训综合服务项目'
            },
            {
              text1: '国家市场监督管理总局中国市场监管报社',
              text2: '与博奥合作开展',
              text3: '食品安全宣传教育系统'
            }
          ],
          newimg: require('../assets/images/time-list10.png')
        },
        {
          time: '2019',
          content: [
            {
              text1: '中国建设教育协会继续教育委员会',
              text2: '与博奥合作运营',
              text3: '住房和城乡建设领域从业人员继续教育网'
            },
            {
              text1: '国家卫生健康委员会',
              text2: '与博奥合作开展',
              text3: '托育行业从业人员培训管理信息系统'
            }
          ],

          newimg: require('../assets/images/time-list11.png')
        },
        {
          time: '2020',
          content: [
            {
              text1: '中国交通建设股份有限公司',
              text2: '委托博奥开展',
              text3: '注册安全工程师继续教育系统'
            },
            {
              text1: '中国中铁股份有限公司',
              text2: '合作开展',
              text3: '职业技能等级评价管理系统'
            }
            
          ],
          newimg: require('../assets/images/time-list12.png')
        },
        {
          time: '2021',
          content: [
            {
              text1: '国家卫生健康委能力建设和继续教育中心',
              text2: '委托博奥开展',
              text3: '健康中国-基层卫生健康队伍能力建设项目信息管理平台'
            },
            {
              text1: '中国消防救援学院',
              text2: '委托博奥开展',
              text3: '中国消防救援学院高等学历继续教育教学平台'
            }
            
          ],
          newimg: require('../assets/images/time-list13.png')
        }
      ]
    }
  },
  methods: {},
  mounted () {},
  created () {
    $(function () {
      $('.timer-scale-cont').eq(0).addClass('hov')
      $('.timer-left').hide()
      var timerNum = 0
      var space = 175
      var length = $('.timer-scale-cont').length
      var numL

      if (window.screen.width > 1500) {
        numL = length - 4
      } else if (window.screen.width < 1500) {
        numL = length - 3
      }

      $('.timer-left').on('click', function () {
        if (timerNum > 0) {
          timerNum -= 1
          moveL(timerNum, numL)
        } else if (timerNum === 0) {
          $('.timer-left').hide()
        }
        // console.log(timerNum)
        tags(timerNum)
      })

      $('.timer-right').on('click', function () {
        if (timerNum < length - 1) {
          $('.timer-left').show()
          timerNum += 1
          tags(timerNum)
        }
        moveL(timerNum, numL)
      })

      $('.time-circle').each(function (index) {
        $(this).on('click', function () {
          $('.timer-left').show()
          timerNum = index
          // console.log(timerNum)
          moveL(timerNum, numL)
          tags(timerNum)
        })
      })
      function tags (num) {
        $('.timer-scale-cont')
          .eq(num)
          .addClass('hov')
          .siblings()
          .removeClass('hov')
      }
      function moveL (num, len) {
        if (num < len) {
          var moveLeft = -num * space
          $('.timer-scale').animate({ left: moveLeft }, 1200)
        }
      }
    })
  }
}
</script>

<style lang="less" scoped>
.body-box {
  width: 1200px;
  margin: 100px auto;
  height: 400px;
}

.timer-shaft-box {
  width: 100%;
  height: 400px;
  padding: 0px 40px;
  box-sizing: border-box;
  position: relative;
}
 .timer-shaft-box{
   transition: all 1s;
    position: relative;
    transform: translateX(10%);
    opacity: 0.1;
 }
 .active .timer-shaft-box{
    transform: translateX(0vh) !important;
    transition-delay: 0.5s;
    opacity: 1 !important;
 }
.timer-shaft {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.timer-left {
  position: absolute;
    top: 14.8%;
    left: -6px;
    z-index: 99;
    width: 47px;
    height: 37px;
    margin-top: -16.5px;
    background-size: cover;
    color: #b00000;
    cursor: pointer;
}
.timer-right {
  position: absolute;
  top: 13.8%;
  right: -9px;
  z-index: 99;
  width: 47px;
    height: 37px;
    margin-top: -10.5px;
    background-size: cover;
    color: #b00000;
    cursor: pointer;
}
.timer-scale {
  position: absolute;
  top: 0;
  left: 0;
  height: 110px;
  padding-left: 110px;
  font-size: 0;
  white-space: nowrap;
}
.timer-scale-cont {
  display: inline-block;
  height: 100%;
  position: relative;
}
.time-circle {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background: transparent;
  border: 2px solid #b00000;
  border-radius: 50%;

  transition: all 0.5s;
  cursor: pointer;
  .timeimg{
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: all 0.5s;
  }
}
.timer-scale-cont.hov .time-circle {
  width: 110px;
  height: 110px;
  .timeimg{
    width: 100%;
    height: 100%;
    opacity: 1;
  }
}
.line-scale {
  display: inline-block;
  vertical-align: middle;
  width: 150px;
  height: 2px;
  margin: 0 2px;
  background: #B00000;
}

.timer-scale-cont{
    .time{
      width: 80px;
      height: 20px;
      text-align: center;
      position: absolute;
      color: #222;
      font-size: 19px;
      font-weight: 500;
      z-index: 99;
          top: -35px;
    left: -31px;
    }
    .time-content{
      position: absolute;
      color: #222;
      font-size: 16px;
      p.text1{
        position: absolute;
        top: 20px;
        left: -10px;
        writing-mode: vertical-lr;
      }
      p.text2{
        position: absolute;
        top: 20px;
        left: 10px;
        writing-mode: vertical-lr;
      }
      .text2-hov,.text1-hov,.text3-hov{display: none;}
    }
}
.time-content-hov{
  display: none;
}
.hov{
  p.text2,p.text1{display: none !important;}
  .time{
      width: 80px;
      height: 20px;
      text-align: center;
      position: absolute;
          color: #b00000;
    font-size: 19px;
    font-weight: 500;
    z-index: 99;
    top: 125px;
    left: 16px;
    }
    .hov-text{
      width: 310px;
    position: absolute;
    top: 45px;
    left: -98px;
    text-align: center;
    }
    .text1-hov{
      width: 100%;
      display: block !important;
        color: #B00000;
        font-size: 16px;
         overflow:hidden;
        white-space: normal;
        word-break: break-all;
      font-weight: 700;
      }
      .text2-hov{
        width: 100%;
         display: block !important;
        color: #787878;
         overflow:hidden;
        white-space: normal;
        word-break: break-all;
        font-size: 14px;
      }
      .text3-hov{
        width: 100%;
         display: block !important;
        overflow:hidden;
        white-space: normal;
        word-break: break-all;
        font-size: 14px;
      }

}
.hov{
  .times0{
  top:105px !important;
}
.times1{
  top:195px !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/develView.vue